import { cn } from '@shared/lib/cn'
import { LoaderCircle } from 'lucide-react'

export function LoadingScreen({ className = '' }: { className?: string }) {
  return (
    <div className={cn('flex flex-1 items-center justify-center bg-bg-base', className)}>
      <LoaderCircle className="size-8 animate-spin text-muted-foreground" />
    </div>
  )
}
